import { motion, AnimatePresence } from 'framer-motion';
import { useState, useEffect } from 'react';
import StartGameOverlay from './StartGameOverlay';
import RetroLoadingDots from './RetroLoadingDots';

const RECENT_SCORES_KEY = 'retro_speedclicker_recent';

const RetroSpeedClicker = ({ 
  isActive = false, 
  onEnd, 
  onGameComplete,
  showStartButton = false,
  isGenerating = false
}) => {
  const [clicks, setClicks] = useState(0);
  const [gameStarted, setGameStarted] = useState(false);
  const [recentScores, setRecentScores] = useState([]);
  // Show start button only when explicitly requested (like in RetroArcade)
  const [waitingToStart, setWaitingToStart] = useState(showStartButton);

  // Initialize game and load scores
  useEffect(() => {
    if (isActive && !gameStarted && !waitingToStart) {
      setClicks(0);
      setGameStarted(true);
      
      // Load recent scores
      const savedRecent = localStorage.getItem(RECENT_SCORES_KEY);
      if (savedRecent) setRecentScores(JSON.parse(savedRecent));
    }
  }, [isActive, waitingToStart]);

  const handleStart = () => {
    setWaitingToStart(false);
  };

  const saveScore = (finalScore) => {
    // Update recent scores
    const newRecent = [finalScore, ...recentScores.slice(0, 4)];
    setRecentScores(newRecent);
    localStorage.setItem(RECENT_SCORES_KEY, JSON.stringify(newRecent));
  };

  const handleClick = () => {
    setClicks(prev => prev + 1);
  };

  return (
    <div className="absolute inset-0 rounded-lg overflow-hidden">
      <div className="absolute inset-0 bg-black" />
      
      <AnimatePresence>
        {waitingToStart ? (
          <StartGameOverlay 
            onStart={handleStart}
            gameName="Speed Clicker"
          />
        ) : (
          <div 
            className="absolute inset-0 flex flex-col items-center justify-center"
            onClick={handleClick}
          >
            {/* Click Counter */}
            <motion.div
              key={clicks}
              initial={{ scale: 1 }}
              animate={{ scale: [1, 1.15, 1] }}
              transition={{ duration: 0.1 }}
              className="text-white font-['VT323'] mb-4"
              style={{ 
                fontSize: `${Math.min(16 + (clicks * 2.1), 120)}px` 
              }}
            >
              {clicks}
            </motion.div>

            {/* Status Text */}
            <div className="text-[18px] text-white/70 font-['VT323']">
              Click anywhere as fast as you can!
            </div>

            {/* Visual Feedback for Clicks */}
            <AnimatePresence>
              {clicks > 0 && (
                <motion.div
                  className="absolute inset-0 bg-white/10"
                  initial={{ opacity: 0.2 }}
                  animate={{ opacity: 0 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.2 }}
                />
              )}
            </AnimatePresence>
          </div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default RetroSpeedClicker; 